import React from "react";
import Typed from "react-typed";
import { HOME_DATA } from "data";
import { handleClickScroll } from "utils";

const MainSection = () => {
  return (
    <div className="text-white" id="home">
      <div className="max-w-[800px] h-screen w-full h-screen mx-auto text-center flex flex-col justify-center">
        <p className="text-[#00df9a] font-bold p-2">
          {HOME_DATA.header.toUpperCase()}
        </p>
        <h1 className="md:text-6xl sm:text-6xl text-6xl font-bold md:py-6">
          {HOME_DATA.subHeader}
        </h1>
        <div className="flex justify-center items-center mb-8">
          <Typed
            className="md:text-4xl sm:text-4xl text-xl font-bold md:pl-4 pl-2"
            strings={HOME_DATA.information}
            typeSpeed={30}
            backSpeed={50}
            loop
          />
        </div>
        <p className="md:text-xl text-xl font-bold text-gray-500">
          {HOME_DATA.description}
        </p>
        <button
          className="bg-[#00df9a] w-[200px] rounded-md font-medium my-6 mx-auto py-3 text-black"
          onClick={() => handleClickScroll("portfolio")}
        >
          Our Work
        </button>
      </div>
    </div>
  );
};

export default MainSection;
